import React, { useEffect, useRef, useCallback } from 'react';
import './CustomCursor.css';

function CustomCursor() {
  const dotRef = useRef(null);
  const ringRef = useRef(null);
  const pos = useRef({ mx: 0, my: 0, dx: 0, dy: 0 });

  const isFinePointer = typeof window !== 'undefined'
    && window.matchMedia('(pointer: fine)').matches;

  const handleMouseMove = useCallback((e) => {
    pos.current.mx = e.clientX;
    pos.current.my = e.clientY;
  }, []);

  useEffect(() => {
    if (!isFinePointer) return;

    document.addEventListener('mousemove', handleMouseMove);
    let raf;

    const loop = () => {
      const { mx, my } = pos.current;
      pos.current.dx += (mx - pos.current.dx) * 0.15;
      pos.current.dy += (my - pos.current.dy) * 0.15;

      if (dotRef.current) {
        dotRef.current.style.transform = `translate(${mx - 4}px, ${my - 4}px)`;
      }
      if (ringRef.current) {
        ringRef.current.style.transform = `translate(${pos.current.dx - 18}px, ${pos.current.dy - 18}px)`;
      }
      raf = requestAnimationFrame(loop);
    };

    raf = requestAnimationFrame(loop);
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      cancelAnimationFrame(raf);
    };
  }, [isFinePointer, handleMouseMove]);

  if (!isFinePointer) return null;

  return (
    <>
      <div className="cursor-dot" ref={dotRef} />
      <div className="cursor-ring" ref={ringRef} />
    </>
  );
}

export default CustomCursor;
